export default __webpack_public_path__ + "media/images/preview-6399aebd96ccf025654e2977454f168f.png";